import { createMuiTheme } from "@material-ui/core/styles";

const temaArco = createMuiTheme({
  palette: {
    primary: {
      main: '#007B96',
      light: '#00B17D'
    },
  },
  typography: {
    fontSize: 20,
    htmlFontSize: 20
  },
  overrides: {
    MuiTypography: {
      gutterBottom: {
        marginBottom: 24,
      },
    },
  },
});

export default temaArco;
